import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { NO_COMPLETED_SNAPSHOT_MESSAGE } from '../../utils/nhStyleFingerprintSnapshot';

function NhStyleFingerprintStatus({ loading, error, snapshot }) {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  if (!snapshot) {
    return (
      <Typography variant="body2" color="text.secondary">
        {NO_COMPLETED_SNAPSHOT_MESSAGE}
      </Typography>
    );
  }

  return null;
}

export default NhStyleFingerprintStatus;
